import { useTranslation } from 'react-i18next';

import BankIcon from 'app/components/Icons/BankIcon';
import CoinsStackedIconSelect from 'app/components/Icons/CoinsStackedIconSelect';
import CoinsSwapIcon from 'app/components/Icons/CoinsSwapIcon';
import GlobusIcon from 'app/components/Icons/GlobusIcon';
import ManatIcon from 'app/components/Icons/ManatIcon';
import SwitchIcon from 'app/components/Icons/SwitchIcon';
import WalletIconSelect from 'app/components/Icons/WalletIconSelect';

export const usePaymentOptions = () => {
  const { t } = useTranslation();

  const paymentOptions = [
    { value: 'payment_acc2acc', label: t('homePage.acc2acc'), icon: <CoinsSwapIcon /> },
    { value: 'payment_interbank', label: t('homePage.inBank'), icon: <BankIcon /> },
    { value: 'payment_local_transfer', label: t('homePage.inCountry'), icon: <ManatIcon /> },
    { value: 'payment_foreign_transfer', label: t('homePage.internal'), icon: <GlobusIcon /> },
    {
      value: 'payment_conversion',
      label: t('homePage.conversion'),
      icon: <SwitchIcon sx={{ width: '20px', height: '20px' }} />,
    },
    { value: 'payment_edv', label: t('homePage.edv'), icon: <CoinsStackedIconSelect /> },
    { value: 'payment_budget', label: t('homePage.stateBudget'), icon: <WalletIconSelect /> },
    // { value: 'Kredit ödənişi', label: t('homePage.credit'), icon: <SaleIcon /> },
  ];

  return paymentOptions;
};
